/**
 * 現在のページに対してグループを管理する
 * タグみたいなイメージ
 *
 * 2024/08時点ではSPAでのみ利用しているがAjaxでも利用してよい
 */
export class LocationGroupStore {
  static getInstance(): LocationGroupStore {
    if (!LocationGroupStore.instance) {
      LocationGroupStore.instance = new LocationGroupStore([])
    }

    return LocationGroupStore.instance
  }

  private static instance: LocationGroupStore

  constructor(
    private list: LocationGroup[]
  ) {}

  setGroupList(groups: LocationGroup[]): void {
    this.list = groups
  }

  locationIsGroupOf(groups: LocationGroup[]): boolean {
    return groups.some(group => this.list.includes(group))
  }
}

export type LocationGroup =
  'cart' |
  'order'
